import {Controller} from '@hotwired/stimulus'

// Collapsible sidebar section (Your Organization / Admin / Super Admin).
//
// Persists under the same localStorage key the React ItemsSection used
// (`sidebar_<name>_collapsed`, via usePersistentState), so a section's state
// survives the GF-2954 HAML conversion. Default is collapsed — the converted
// sections all rendered without expandedByDefault.
export default class extends Controller {
  static targets = ['items', 'button']

  static values = {
    name: String,
    defaultCollapsed: {type: Boolean, default: false},
  }

  connect() {
    this.render(this.readStoredCollapsed())
  }

  toggle() {
    this.render(!this.collapsed)
  }

  get collapsed() {
    return this.element.classList.contains('side-bar-section--collapsed')
  }

  get storageKey() {
    return `sidebar_${this.nameValue}_collapsed`
  }

  readStoredCollapsed() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.storageKey) || 'null')
      return typeof stored === 'boolean' ? stored : this.defaultCollapsedValue
    } catch (e) {
      return this.defaultCollapsedValue
    }
  }

  render(collapsed) {
    this.element.classList.toggle('side-bar-section--collapsed', collapsed)
    if (this.hasItemsTarget)
      this.itemsTarget.hidden = collapsed

    if (this.hasButtonTarget)
      this.buttonTarget.setAttribute('aria-expanded', collapsed ? 'false' : 'true')

    try {
      localStorage.setItem(this.storageKey, JSON.stringify(collapsed))
    } catch (e) {
      // localStorage unavailable — persistence is best-effort.
    }
  }
}
